import React, { PropsWithChildren } from 'react'
import { useAppSelector } from '../../State/Store';
import { GlobalError } from './GlobalError';

export const ErrorGate = ({children}:PropsWithChildren) => {
    const err = useAppSelector(s => s.ui.lastError);
  if (err!=null) {
    // Show ONLY the global error page; hide the rest of the app
    return <GlobalError />;
  }
  return <>{children}</>;
}
